import { useQuery } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useFetchProvidersSettings = (enabled: boolean) => {
  const response = useQuery({
    queryKey: ['useFetchProvidersSettings', enabled],
    queryFn: api.providers.getSmsProviders,
    gcTime: 0,
    enabled,
  })

  if(response.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузке конфигурации провайдеров',
      description: response.error.message,
    })
  }

  return response
}
